var React = require('react');

function TwitterFilledInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.32 6.44a.5.5 0 00-.2-.87l-.79-.2a.5.5 0 01-.33-.7l.44-.89a.5.5 0 00-.58-.7l-2 .56a.5.5 0 01-.44-.08 5 5 0 00-8 4v.36a.25.25 0 01-.22.25c-2.81.33-5.5-1.1-8.4-4.44a.51.51 0 00-.51-.15A.5.5 0 003 4a7.58 7.58 0 00.46 4.92.25.25 0 01-.26.36l-1.12-.22a.5.5 0 00-.57.59 5.15 5.15 0 002.37 3.78.25.25 0 010 .45l-.53.21a.5.5 0 00-.26.69 4.36 4.36 0 003.2 2.48.25.25 0 010 .47c-1.36.562-2.819.845-4.29.83a.51.51 0 00-.2 1 20.06 20.06 0 008.14 1.93 12.58 12.58 0 007-2A12.5 12.5 0 0022.5 9.06v-.87a.501.501 0 01.18-.38l1.64-1.37z","fill":"currentColor"}));
}

TwitterFilledInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = TwitterFilledInline;

TwitterFilledInline.default = TwitterFilledInline;
